<p-toast />
<main class="bg-white min-w-screen min-h-screen">
  <router-outlet />
</main>
